'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propAliases = exports.propNames = exports.propTypes = exports.transform = exports.text = exports.spacing = exports.position = exports.overflow = exports.opacity = exports.list = exports.layout = exports.interaction = exports.flex = exports.dimensions = exports.boxShadow = exports.borders = exports.borderRadius = exports.background = exports.css = exports.splitBoxProps = exports.splitProps = exports.default = undefined;

var _glamor = require('glamor');

Object.defineProperty(exports, 'css', {
  enumerable: true,
  get: function get() {
    return _glamor.css;
  }
});

var _enhancers = require('./enhancers');

Object.defineProperty(exports, 'background', {
  enumerable: true,
  get: function get() {
    return _enhancers.background;
  }
});
Object.defineProperty(exports, 'borderRadius', {
  enumerable: true,
  get: function get() {
    return _enhancers.borderRadius;
  }
});
Object.defineProperty(exports, 'borders', {
  enumerable: true,
  get: function get() {
    return _enhancers.borders;
  }
});
Object.defineProperty(exports, 'boxShadow', {
  enumerable: true,
  get: function get() {
    return _enhancers.boxShadow;
  }
});
Object.defineProperty(exports, 'dimensions', {
  enumerable: true,
  get: function get() {
    return _enhancers.dimensions;
  }
});
Object.defineProperty(exports, 'flex', {
  enumerable: true,
  get: function get() {
    return _enhancers.flex;
  }
});
Object.defineProperty(exports, 'interaction', {
  enumerable: true,
  get: function get() {
    return _enhancers.interaction;
  }
});
Object.defineProperty(exports, 'layout', {
  enumerable: true,
  get: function get() {
    return _enhancers.layout;
  }
});
Object.defineProperty(exports, 'list', {
  enumerable: true,
  get: function get() {
    return _enhancers.list;
  }
});
Object.defineProperty(exports, 'opacity', {
  enumerable: true,
  get: function get() {
    return _enhancers.opacity;
  }
});
Object.defineProperty(exports, 'overflow', {
  enumerable: true,
  get: function get() {
    return _enhancers.overflow;
  }
});
Object.defineProperty(exports, 'position', {
  enumerable: true,
  get: function get() {
    return _enhancers.position;
  }
});
Object.defineProperty(exports, 'spacing', {
  enumerable: true,
  get: function get() {
    return _enhancers.spacing;
  }
});
Object.defineProperty(exports, 'text', {
  enumerable: true,
  get: function get() {
    return _enhancers.text;
  }
});
Object.defineProperty(exports, 'transform', {
  enumerable: true,
  get: function get() {
    return _enhancers.transform;
  }
});
Object.defineProperty(exports, 'propTypes', {
  enumerable: true,
  get: function get() {
    return _enhancers.propTypes;
  }
});
Object.defineProperty(exports, 'propNames', {
  enumerable: true,
  get: function get() {
    return _enhancers.propNames;
  }
});
Object.defineProperty(exports, 'propAliases', {
  enumerable: true,
  get: function get() {
    return _enhancers.propAliases;
  }
});
Object.defineProperty(exports, 'propEnhancers', {
  enumerable: true,
  get: function get() {
    return _enhancers.propEnhancers;
  }
});
exports.hydrate = hydrate;
exports.extractStyles = extractStyles;
exports.clearStyles = clearStyles;

var _cache = require('./cache');

var cache = _interopRequireWildcard(_cache);

var _styles = require('./styles');

var styles = _interopRequireWildcard(_styles);

var _box = require('./box');

var _box2 = _interopRequireDefault(_box);

var _splitProps2 = require('./utils/split-props');

var _splitProps3 = _interopRequireDefault(_splitProps2);

var _splitBoxProps2 = require('./utils/split-box-props');

var _splitBoxProps3 = _interopRequireDefault(_splitBoxProps2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

exports.default = _box2.default;
exports.splitProps = _splitProps3.default;
exports.splitBoxProps = _splitBoxProps3.default;

function hydrate(entries) {
  cache.hydrate(entries);
}

function extractStyles() {
  var output = {
    cache: cache.entries(),
    styles: styles.getAll()
  };
  clearStyles();
  return output;
}

function clearStyles() {
  cache.clear();
  styles.clear();
}